import React from 'react'
import { CategoryTitle, JuridicalProcess as LegalProcess } from 'components'
import styles from './JuridicalProcess.module.scss'

const JuridicalProcess = ({ stage, judicialProcessTimeline }) => {
  if (stage !== 'venda_judicial') return null

  return (
    <section className={styles.juridicalProcess}>
      <CategoryTitle icon="stage" title="Processo jurídico" />
      <div className={styles.stage}>
        <LegalProcess processStage={judicialProcessTimeline} />
      </div>
    </section>
  )
}

export default JuridicalProcess
